<template>
	<div
		:class="[
			'w-full divide-y divide-won-green overflow-hidden rounded-lg border border-gray-200 bg-white',
			'md:grid md:divide-x md:divide-y-0',
			showCoaching ? 'md:grid-cols-3' : 'md:grid-cols-2',
		]"
	>
		<BasicPlanColumn
			:cta-label="basicCtaLabel"
			:cta-disabled="!allowExitToFreePlan"
			@cta="emit('upgrade-later')"
		/>
		<PremiumPlanColumn
			:mode="hasSubscription ? 'current' : 'offer'"
			@select="emit('select', $event)"
		>
			<template #controls>
				<CurrentPlanControls />
			</template>
		</PremiumPlanColumn>
		<CoachingCallCard v-if="showCoaching" />
	</div>
</template>

<script setup>
import { computed } from 'vue';

import BasicPlanColumn from './basic-plan-column.vue';
import PremiumPlanColumn from './premium-plan-column.vue';
import CoachingCallCard from '../subscription/coaching-call-card.vue';
import CurrentPlanControls from '../subscription/current-plan-controls.vue';
import { useSubscriptionPlanStore } from '../../../store/subscription.store';

/**
 * Basic | Premium/God Mode | 1:1 Coaching in one bordered table (EN-1026). Below `md` the
 * columns stack into rows whose feature lists open independently, Premium first (EN-1027).
 */
const props = defineProps({
	// Coaching is only sold in some locations, so the table has two or three columns.
	showCoaching: {
		type: Boolean,
		default: false,
	},
	// The feature-limit modal lets a free user leave with "Upgrade later".
	allowExitToFreePlan: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['select', 'upgrade-later']);

const subscriptionStore = useSubscriptionPlanStore();
const hasSubscription = computed(() => subscriptionStore.hasSubscription);

const basicCtaLabel = computed(() => {
	if (hasSubscription.value) {
		return null;
	}

	return props.allowExitToFreePlan ? 'Upgrade later' : 'Current Plan';
});
</script>
